import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

/**
 * Text field component that integrates with React Hook Form
 * Uses MUI TextField and handles validation, errors, etc.
 */
interface FormTextFieldProps extends Omit<TextFieldProps, 'name'> {
  name: string;
  helperText?: string;
}

export const FormTextField: React.FC<FormTextFieldProps> = ({
  name,
  helperText,
  required,
  ...other
}) => {
  const { control, formState: { errors } } = useFormContext();
  const errorMessage = errors[name]?.message as string | undefined;
  
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? ''}
          fullWidth
          error={!!errorMessage}
          helperText={errorMessage || helperText}
          required={required}
          {...other}
        />
      )}
    />
  );
};

export default FormTextField;